module.exports = __webpack_public_path__ + "img/corto_dx.6ff70e0d.png";